import { Switch } from '@mui/material';
import { useStyles } from './styles';

const IosToggle = ({ ...props }) => {
    const classes = useStyles();
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
};

export default IosToggle;
